"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.facebook.com/docs/javascript/reference/
 */
exports.default = ["__globalCallbacks", "api", "AppEvents", "getLoginStatus", "getAuthResponse", "getAccessToken", "getUserID", "login", "logout", "Canvas", "Event", "Frictionless", "init", "ui", "XFBML"];